module.exports = __webpack_public_path__ + "static/media/skyline-invoice-header.85fbbff6.png";